import React, { Fragment } from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Button from './Button';

class ButtonCol extends AbstractComponent {             
    show() {
        if(!this.props.visible)
            return ;

        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >
                <div>                    
                    <Button                                    
                        type="button" 
                        id={this.props.id}
                        nome={this.props.nome}
                        className={"form-control " + this.props.className}
                        background={this.props.background}
                        color={false}
                        style={{
                            width: this.props.width,
                            marginTop: this.props.marginTop
                        }}                                
                        onClick={() => {this.props.onClick()}}
                    >
                        {this.props.children}
                    </Button>                    

                    {
                        this.props.showSpan &&
                        <span className="help-block">
                            
                        </span>
                    }
                </div>
            </Col>
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}
            </Fragment>  
        )
    }
}

ButtonCol.defaultProps = {
    md: 12,
    visible: true,
    background: 3,
    className: "btn btn-primary",
    width: '100%',
    marginTop: '26px',
    showSpan: true
};

export default ButtonCol;